module.exports = __webpack_public_path__ + "a5c3383b587a9f1947b33f7b6fa8aec2.mp3";